import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const RequireAuth = () => {
  const { auth } = useAuth();
  const location = useLocation();
  if (auth?.accessToken && auth?.role === "unconfirmed") {
    return <Navigate to="/unconfirmed" state={{ from: location }} replace />;
  }
  return auth?.accessToken && auth?.role === "user" ? (
    <Outlet />
  ) : auth?.user ? (
    <Navigate to="/unauthorized" state={{ from: location }} replace />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default RequireAuth;
